import styled from 'styled-components';

import { RegularBase } from 'modules/ui/typography';

import { Colors } from 'modules/ui/theme/colors';

export const Label = styled(RegularBase)`
  color: ${Colors.SolidGray};
`;
